import React from 'react';
import PropTypes from 'prop-types';

import TableReport from '@componentes/TableReport';
import Table from './Table';
import IntlMessage from '../../../../../helpers/intlMessage';

const ImpressaoLaudosCriticos = ({ lista }) => (
  <TableReport
    title={<IntlMessage id='general.requestsPanel.requestsMade' />}
    assinatura={<IntlMessage id='general.requestsPanel.signature' />}
  >
    {lista.map((item, i) => (
      <tr key={i} style={{ border: 0 }}>
        <td style={{ border: 0, padding: 0 }}>
          <Table item={item} />
        </td>
      </tr>
    ))}
  </TableReport>
);

ImpressaoLaudosCriticos.propTypes = {
  lista: PropTypes.array.isRequired
};

ImpressaoLaudosCriticos.defaultProps = {
  lista: []
};

export default ImpressaoLaudosCriticos;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Solicitacoes/Relatorio/Impressao/index.js